import { HTTP_TOKEN } from "./http";


export const getSales = (params) => {
  return HTTP_TOKEN.get("sale", { params }).then((result) => {
    return result.data;
  });
};

export const getSale = (sale_id) => {
  return HTTP_TOKEN.get(`sale/${sale_id}`).then((result) => {
    return result.data;
  });
};
